import * as _ from 'lodash';
import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';
import { ServicePreferences } from '@services';

@Pipe({
    name: 'i2KnMonth'
})
export class I2KnMonth implements PipeTransform {

    constructor(
        private servicePreferences: ServicePreferences
    ) {
    }

    transform(value: any, args?: any): any {
        if(!value){
            return;
        }
        const language = this.servicePreferences.getPreference('language');
        const dateTimeFormatMoment = this.servicePreferences.getPreference('dateTimeFormatMoment');
        const timezone = this.servicePreferences.getPreference('timezone');

        return _.upperFirst(moment(moment.tz(value, timezone)).locale(language).format('MMMM YYYY'));
    }
}
